import { render, staticRenderFns } from "./simpleUploader.vue?vue&type=template&id=a47a1024&scoped=true"
import script from "./simpleUploader.vue?vue&type=script&lang=js"
export * from "./simpleUploader.vue?vue&type=script&lang=js"
import style0 from "./simpleUploader.vue?vue&type=style&index=0&id=a47a1024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47a1024",
  null
  
)

export default component.exports